export default __webpack_public_path__ + "static/media/david_roberin.8bd635b0.png";